import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { BasysMapFrameService, ViewStateChangeArgType } from '@barthauer/basys/map-frame';
import { Subscription } from 'rxjs';
import { ComponentDataSource } from '../../models/componentDataSource.model';
import { AppService } from '../../services/app.service';
import { FrameService } from '../../services/frame.service';
import { ViewModelHelper } from '../../shared/helpers';
import { IMobileResourceType, MobileResourceTypeViewModel } from '../../viewModels/mobileData.resources.viewModel';
import { ResourcesDataContext } from '../resources.model';
import { ResourcesService } from '../resources.service';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
  // animations: [resourcesAnimation],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ResourcesComponent implements OnInit, OnDestroy {
  public res = ResourceSet.Empty;
  AppService = AppService;
  public dataSource: ComponentDataSource<IMobileResourceType>;
  ViewModelHelper = ViewModelHelper;
  private dataContext: ResourcesDataContext;
  private subscriptions: Subscription[] = [];

  constructor(
    public frame: BasysMapFrameService,
    private frameService: FrameService,
    public resourcesService: ResourcesService,
    private appResService: ResourceManagerService,
  ) {
    this.dataSource = new ComponentDataSource();
    this.dataContext = new ResourcesDataContext();

    this.subscriptions.push(
      this.frameService.onMobileResourceTypesSent().subscribe((restvp) => {
        this.setDataSource(restvp.allResourceTypes);
      }),
    );

    this.subscriptions.push(
      frame.lib.onViewStateChanged().subscribe((args) => {
        switch (args.type) {
          case ViewStateChangeArgType.BottomSheetPanelOpened: {
            if (frame.routing.getCurrentConfig().designation === AppService.Route_ResourceList) {
              this.dataContext.workId = undefined;
            }
            resourcesService.sendDataContext(this.dataContext);
            break;
          }
        }
      }),
    );
  }

  async ngOnInit() {
    this.res = await this.appResService.getResourceSet('abc-maintenance-opera');
  }

  private setDataSource(resTypes: MobileResourceTypeViewModel[]): void {
    if (this.dataSource.rawData !== resTypes) {
      this.dataSource.rawData = resTypes;
      this.dataContext.dsResourceTypes = resTypes;
    }
  }

  ngOnDestroy() {
    console.log('resources_destroy');
    this.subscriptions.forEach((element) => {
      element.unsubscribe();
    });
    this.frameService.dispose();
  }
}
